import React from 'react';
import {
  Form,
  Col,
  Image,
  FormFile,
  Button,
  FormGroup,
  InputGroup
} from 'react-bootstrap';
import Select from 'react-select';
import _ from 'lodash';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import Swal from 'sweetalert2';
import fiteAPI from '../fiterAPI';

const getCourseName = (courseId, courses) => {
  return _.get(
    _.filter(courses, ({ id }) => id === courseId),
    '[0].name',
    '-'
  );
};

const getRoleNameMask = roleName => {
  if (roleName === 'Coordinator') return 'Coordenador';
  if (roleName === 'Student' || !roleName) return 'Estudante';
  return roleName;
};

const getDateMask = date =>
  (moment.isDate(date) && moment(date).format('DD/MM/YYYY')) || '-';

const DEFAULT_AVATAR =
  'data:image/png;base64,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';

class UserForm extends React.Component {
  constructor() {
    super();

    this.state = {
      currentSelfieURL: DEFAULT_AVATAR,
      name: '',
      birthday: '',
      email: '',
      selfie: '',
      subject: '',
      empoyledOrStudying: '',
      interestAreas: []
    };

    this.handleImageChange = this.handleImageChange.bind(this);
    this.handleNameChange = this.handleTextChange('name').bind(this);
    this.handleBirthdayChange = this.handleTextChange('birthday').bind(this);
    this.handleEmailChange = this.handleTextChange('email').bind(this);
    this.handleSubjectChange = this.handleTextChange('subject').bind(this);
    this.onSaveChanges = this.onSaveChanges.bind(this);
  }

  componentDidMount() {
    const {
      name,
      birthday,
      email,
      selfie,
      subject,
      empoyledOrStudying,
      interestAreas
    } = this.props.userProfileData;
    if (selfie && selfie._url) this.setState({ currentSelfieURL: selfie._url });
    this.setState({
      name,
      birthday: getDateMask(birthday),
      email,
      selfie,
      subject,
      empoyledOrStudying,
      areasList: this.props.areasList
        ? this.props.areasList.map(area => ({ ...area, value: area.id }))
        : []
    });
  }

  async onSaveChanges() {
    const {
      name,
      birthday,
      email,
      selfie,
      subject,
      empoyledOrStudying,
      interestAreas
    } = this.state;
    if (!name || !birthday) {
      Swal.fire({
        title: `Preencha o ${!name ? ' nome.' : ' aniversário'}`,
        icon: 'warning'
      });
      return;
    }
    this.props.turnOnLoading();

    await fiteAPI.updateUser({
      name,
      birthday: moment(birthday, 'DD-MM-YYYY').toDate(),
      email,
      selfie,
      subject,
      empoyledOrStudying,
      interestAreas: interestAreas ? interestAreas.map(area => area.value) : []
    });
    this.props.setCurrentUser();
  }

  handleTextChange = fieldName => event => {
    let { value } = event.target;
    if (fieldName === 'birthday') {
      value = this.customFormatToDate(value.toString());
    } else {
      this.setState({ [fieldName]: value });
    }
  };

  handleImageChange = event => {
    const selfie = event.target.files[0];
    if (!selfie) return this.setState({ currentSelfieURL: DEFAULT_AVATAR });
    const currentSelfieURL = URL.createObjectURL(selfie);
    this.setState({ currentSelfieURL, selfie });
  };

  handleAreaChange = async area => {
    try {
      if (area.length > 2) {
        alert('Você deve escolher no máximo 2 áreas');
      } else {
        this.setState({ interestAreas: area });
      }
    } catch {
      this.setState({ interestAreas: area });
    }
  };

  customFormatToDate = str => {
    const { birthday } = this.state;
    if (
      str &&
      (str.length === 2 || str.length === 5) &&
      birthday.length + 1 === str.length
    )
      return `${str}/`;
    if (str && str.length > 10) return str.slice(0, -1);
    return str;
  };

  openCVLink = () => {
    window.open();
  };

  render() {
    const { userProfileData = {}, courses = [], currentUser } = this.props;
    const {
      currentSelfieURL,
      name,
      birthday,
      email,
      subject,
      empoyledOrStudying,
      areasList,
      interestAreas
    } = this.state;

    const { currentAvatar } = this.props;
    return (
      <Form>
        <Form.Row className="mb-4">
          <Col xs={6} md={12}>
            <Image
              src={currentSelfieURL}
              roundedCircle
              style={{ height: '80px', width: '80px' }}
            />
          </Col>
        </Form.Row>
        <Form.Row>
          <Col>
            {' '}
            <FormFile>
              <FormFile.Input
                onChange={this.handleImageChange}
                style={{ display: 'none' }}
                id="files"
              />
              <label htmlFor="files" className="btn btn-light">
                <FontAwesomeIcon icon={faEdit} className="mr-2" />
                Altere sua foto de perfil
              </label>
            </FormFile>
          </Col>
        </Form.Row>
        <Form.Row>
          <Col md={6}>
            <FormGroup>
              <Form.Label style={{ fontWeight: 'bold' }}>
                Situação atual
              </Form.Label>
              <Form.Control
                as="select"
                onChange={() =>
                  this.setState({
                    empoyledOrStudying: !this.state.empoyledOrStudying
                  })
                }
                defaultValue={currentUser.empoyledOrStudying}
              >
                <option value>
                  Estou{' '}
                  {currentAvatar.empoyledOrStudying == 'studying'
                    ? 'Estudando'
                    : 'Trabalhando'}{' '}
                  atualmente
                </option>
                <option value={false}>
                  Não estou{' '}
                  {currentAvatar.empoyledOrStudying == 'studying'
                    ? 'Estudando'
                    : 'Trabalhando'}{' '}
                  atualmente
                </option>
                ))
              </Form.Control>
            </FormGroup>
          </Col>
          {/* <Col>
            <Form.Group as={Col} controlId="formGridName">
              <Form.Label style={{ fontWeight: 'bold' }}>
                Áreas de interesse
              </Form.Label>
              <Select
                value={interestAreas}
                onChange={this.handleAreaChange}
                options={areasList}
                isMulti
                className="select-filter"
                placeholder="Selecione até duas áreas de interesse"
              />
            </Form.Group>
          </Col> */}
        </Form.Row>
        <Form.Row>
          <Form.Group as={Col} controlId="formGridName">
            <Form.Label style={{ fontWeight: 'bold' }}>Nome</Form.Label>
            <Form.Control
              disabled
              type="text"
              value={name || ''}
              onChange={this.handleNameChange}
            />
          </Form.Group>
          <Form.Group as={Col} controlId="formGridEmail">
            <Form.Label style={{ fontWeight: 'bold' }}>Email</Form.Label>
            <Form.Control
              disabled
              type="email"
              value={email || ''}
              onChange={this.handleEmailChange}
            />
            <Form.Control.Feedback type="invalid">
              Email inválido
            </Form.Control.Feedback>
          </Form.Group>
        </Form.Row>

        <Form.Row>
          <Form.Group as={Col} controlId="formGridBirthday" md={6}>
            <Form.Label style={{ fontWeight: 'bold' }}>
              Data de nascimento
            </Form.Label>
            <Form.Control
              disabled
              type="text"
              value={birthday || ''}
              onChange={this.handleBirthdayChange}
            />
          </Form.Group>
        </Form.Row>

        <Form.Row>
          <Form.Group as={Col} controlId="formGridCPF">
            <Form.Label style={{ fontWeight: 'bold' }}>CPF</Form.Label>
            <Form.Control
              plaintext
              readOnly
              type="text"
              defaultValue={_.get(userProfileData, 'cpf', '-')}
            />
          </Form.Group>

          <Form.Group as={Col} controlId="formGridCourse">
            <Form.Label style={{ fontWeight: 'bold' }}>
              {currentAvatar.groupName}
            </Form.Label>
            <Form.Control
              plaintext
              readOnly
              type="text"
              defaultValue={userProfileData.courseLabel}
            />
          </Form.Group>
        </Form.Row>

        <Form.Group controlId="formGridRole">
          <Form.Label style={{ fontWeight: 'bold' }}>Tipo de Perfil</Form.Label>
          <Form.Control
            plaintext
            readOnly
            type="text"
            defaultValue={getRoleNameMask(_.get(userProfileData, 'roleName'))}
          />
        </Form.Group>

        {/* <Form.Group controlId="exampleForm.ControlTextarea1">
          <Form.Label style={{ fontWeight: 'bold' }}>
            Resumo profissional
          </Form.Label>
          <Form.Control
            as="textarea"
            rows="3"
            value={subject || ''}
            onChange={this.handleSubjectChange}
          />
        </Form.Group> */}

        <Form.Row>
          <Form.Group as={Col}>
            <Button onClick={this.onSaveChanges}>Salvar alterações</Button>
          </Form.Group>
          {/* <Form.Group as={Col}>
            <Link to={`/cv/${currentUser.id}`} className="btn btn-primary">
              Acesse seu CV
            </Link>
          </Form.Group> */}
        </Form.Row>
      </Form>
    );
  }
}

export default UserForm;
